import { styled } from '@mui/material';
import MarkerSvg from '@/assets/svg/marker.svg?react';

export const StyledBerthMarkerDefaultSvg = styled(MarkerSvg)(({ theme }) => ({
  'circle:nth-of-type(1)': { fill: theme.palette.primary.main },
  height: '27px',
}));

export const BerthMarkerBlackSvg = styled(MarkerSvg)(({ theme }) => ({
  'circle:nth-of-type(1)': { fill: theme.palette.text.primary },
  height: '27px',
}));

export const DisabledBerthIcon = styled(MarkerSvg)(({ theme }) => ({
  'circle:nth-of-type(1)': { fill: theme.palette.disabled.main },
  height: '27px',
}));

export function MarkerIcon({ fill }: { fill: string }) {
  return (
    <svg width="30px" height="30px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <rect id="path-1" x="0" y="0" width="30" height="30" rx="30" />
      </defs>
      <g id="Main" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle id="outer-circle" fill={fill} cx="15" cy="15" r="15" />
        <circle fill="#FFF" cx="15" cy="15" r="5" />
      </g>
    </svg>
  );
}
